module.exports = __webpack_public_path__ + "img/IA.3f1d6316.png";